module.exports = __webpack_public_path__ + "static/media/illuEuropraid2017_2_01_thumb_hover.f5c767ad.png";